<template>
  <div
    class="py-4 px-6 cursor-pointer rounded"
    @mouseleave="isObserverCardHover = false"
    @mouseover="isObserverCardHover = true"
  >
    <div
      :id="`submission-assessment-${submission.id}`"
      :class="{ 'with-bottom-border': show_assessment }"
      @click="toggleViewByPassAssessment"
    >
      <div class="flex items-center justify-between w-full">
        <div class="flex items-center">
          <img
            :src="submission.user.avatar_url"
            class="w-8 h-8 rounded-full"
            @click.stop="openAnonymityModal"
          />
          <div
            class="ml-3 text-sm font-semibold"
            :class="handleHoverObveserverCard"
          >
            {{ submission.user.name }}
            <button
              v-if="is_my_submission && getCurrentRT.hard_close === false"
              @click="goToSubmitResponsePage()"
              class="text-pinky ml-3 bg-white hover:underline rounded text-xs font-semibold"
            >
              Write my response
            </button>
          </div>
        </div>
        <p class="cursor-pointer text-xs text-gray-400">
          <span class="font-medium text-gray-400 mr-1.5"
            >Joined discussion on:</span
          >
          {{ submission_by_pass_date }}
        </p>
      </div>
      <div class="pl-11 mt-3 mb-2">
        <button
          :class="
            show_assessment && hasEvaluation(submission)
              ? 'bg-blueGray-500 text-white'
              : 'bg-gray-100 text-gray-400'
          "
          v-if="is_allowed_to_view_assessment"
          @click.stop="toggleViewByPassAssessment"
          class="flex items-center px-5 py-2 bg-gray-100 hover:text-white rounded cursor-pointer text-xs font-semibold hover:bg-blueGray-500"
        >
          Assessment
          <i
            v-if="hasEvaluation(submission)"
            class="fas fa-check ml-2 text-green-500"
          ></i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { EventBus } from 'utils/event-bus';
  import { mapGetters } from 'vuex';
  import moment from 'moment';

  export default Vue.extend({
    data() {
      return {
        show_by_pass_assesment_local_data: false,
        isObserverCardHover: false,
      };
    },
    components: {},
    computed: {
      ...mapGetters([
        'getStudentSummary',
        'getMyRTUserDetails',
        'getCurrentRT',
        'getProfile',
      ]),
      show_assessment() {
        return this.show_by_pass_assesment_local_data
          ? this.student_summary_is_in_state
          : this.show_by_pass_assesment_local_data;
      },
      student_summary_is_in_state() {
        return this.getStudentSummary.submission_id === this.submission.id;
      },
      submission_by_pass_date() {
        return moment(this.submission.by_pass_date, moment.ISO_8601).format(
          'MMMM Do[,] YYYY h:mm A'
        );
      },
      is_my_submission() {
        return this.getMyRTUserDetails.id === this.submission.user.id;
      },
      is_allowed_to_view_assessment() {
        return (
          this.getMyRTUserDetails.id === this.submission.user.id ||
          this.getProfile.id === this.getCurrentRT.author_id
        );
      },
      handleHoverObveserverCard: function () {
        return this.isObserverCardHover ? 'text-primary' : 'text-gray-700';
      },
    },
    props: {
      submission: {
        type: Object,
        default() {
          return {};
        },
      },
      showAssessmentByDefault: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      goToSubmitResponsePage() {
        EventBus.$emit('handleTab', 'prompt');
      },
      async toggleViewByPassAssessment() {
        if (
          !this.student_summary_is_in_state &&
          this.is_allowed_to_view_assessment
        ) {
          this.show_by_pass_assesment_local_data = true;
          await this.$store.dispatch(
            'getSubmissionSummary',
            this.submission.id
          );
        }
        this.$emit('openAssessmentTab');
      },
      hasEvaluation(submission) {
        return (
          submission.assessments.length ||
          (submission.evaluation &&
            ((submission.evaluation.auto_save === false &&
              submission.evaluation.comment) ||
              (submission.evaluation.auto_save &&
                !submission.evaluation.comment)))
        );
      },
    },
    mounted() {
      this.show_by_pass_assesment_local_data = this.showAssessmentByDefault;
      EventBus.$on('scroll-to-assessment-in-feed', ({ submissionID }) => {
        const isMySubmission = submissionID === this.submission.id;
        if (isMySubmission) this.toggleViewByPassAssessment();
      });
      if (this.$route.name === 'course.student-reports.discussion')
        this.toggleViewByPassAssessment();
    },
  });
</script>



// WEBPACK FOOTER //
// byPassCard.vue?76e85bb9